import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgotPassword/reducer";
import ProfileReducer from "./auth/profile/reducer";

//tosts
import toastReducer from "./toast/reducer";

// User
import userReducer from "./users/reducer";


const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  toast: toastReducer,
  user: userReducer,
});

export default rootReducer;
